import EstadoSustentacaoOral, { ESTADO_SUSTENTACAO_ORAL } from '@/dominio/EstadoSustentacaoOral';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import SituacaoInscricaoAdvogado, { SITUACAO_INSCRICAO_ADVOGADO } from '@/dominio/SituacaoInscricaoAdvogado';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import Configuracao from '@/util/Configuracao';
import { Delete, History } from '@mui/icons-material';
import Warning from '@mui/icons-material/Warning';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../css/processo.css';
import ModalEdicaoAdvogadoProcesso from './ModalEdicaoAdvogadoProcesso';
import PopoverSecretaria from './PopoverSecretaria';
import ReactComponent from './ReactComponent';
import SustentacaoOralAnterior from './SustentacaoOralAnterior';
import TableAdvogado from './TableAdvogado';
import ModalConfirmacao, { TIPO_CONFIRMACAO } from './sessao/ModalConfirmacao';
import IconeAdvogado from './sessao/icones/IconeAdvogado';
import IconeAdvogadoModoParticipacao from './sessao/icones/IconeAdvogadoModoParticipacao';
import ExibirOcultarNome from './shared/ExibirOcultarNome';

class PedidosSustentacaoOral extends ReactComponent {
    abrirPopoverPresencaAdvogado;
    inscricaoAdvogado;
    modaisConfirmacaoExclusao = new Map();
    processandoExclusao = new Map();
    processandoPresencaParticipacao = new Map();

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirPopoverPresencaAdvogado: observable,
            inscricaoAdvogado: observable,
            modaisConfirmacaoExclusao: observable,
            processandoExclusao: observable,
            processandoPresencaParticipacao: observable,
            registro: computed,
            listaPartes: computed,
            isProcessoEmJulgamentoVirtual: computed,
            isJulgamentoPresencial: computed,
            isJulgamentoExclusivamenteVirtual: computed,
            renderOpcaoParticipacaoVirtual: computed,
            renderOpcaoPedidoDestaque: computed,
            renderOpcaoSustentacaoOralEletronica: computed,
            handleClickExclusaoAdv: action,
            handleClickCancelarExclusaoAdv: action,
            abrirModalConfirmacaoExclusao: action,
            fecharModalConfirmacaoExclusao: action,
            excluirSustentacaoOral: action,
            handleChangePresencaAdvogado: action,
            handleChangeParticipacaoAdvogado: action,
            handleChangeEstadoSustentacaoOral: action,
            gravarInformacoesParticipacaoAdvogado: action,
            handleClickIconePresencaAdvogado: action,
            handleClosePresencaAdvogado: action
        });

        runInAction(() => {
            this.abrirPopoverPresencaAdvogado = false;
            this.inscricaoAdvogado = null;
        });

        this.createReaction(
            reaction(
                () => this.registro,
                () => {
                    console.debug('Reagindo a alteração de "this.registro" [PedidosSustentacaoOral::reaction]...');
                    this.modaisConfirmacaoExclusao = new Map();
                }
            )
        );
    }

    isPresencaDesabilitada(adv) {
        return (
            this.isInscricaoTransportada(adv) ||
            this.isJulgamentoExclusivamenteVirtual ||
            !!(adv.modoParticipacao && adv.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo)
        );
    }

    isInscricaoTransportada(adv) {
        return !!adv?.sessaoOrigemInscricao;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get listaPartes() {
        const registro = this.registro;
        const partes = [];

        if (registro?.detalhes?.partesProcessuais) {
            registro.detalhes.partesProcessuais.forEach((partesProcesso) => {
                partesProcesso.partes.forEach((parte) => {
                    partes.push(parte.parte);
                });
            });
        }

        return partes;
    }

    handleClickExclusaoAdv = (advogado, codigoDaParte) => {
        const chaveModal = this.gerarChaveModal(advogado, codigoDaParte);

        if (this.processandoExclusao.get(chaveModal)) {
            this.fecharModalConfirmacaoExclusao(chaveModal);
        } else {
            this.abrirModalConfirmacaoExclusao(chaveModal);
        }
    };

    handleClickCancelarExclusaoAdv = (advogado, codigoDaParte) => {
        const chaveModal = this.gerarChaveModal(advogado, codigoDaParte);
        this.fecharModalConfirmacaoExclusao(chaveModal);
    };

    abrirModalConfirmacaoExclusao = (chaveModal) => {
        this.modaisConfirmacaoExclusao.set(chaveModal, true);
    };

    fecharModalConfirmacaoExclusao = (chaveModal) => {
        this.modaisConfirmacaoExclusao.set(chaveModal, false);
    };

    gerarChaveModal(advogado, codigoDaParte) {
        const advId = this.salaSessaoStore.getRepresentanteKey(advogado);
        return `${this.registro.processo.numeroCompleto}|${advId}|${codigoDaParte}`;
    }

    excluirSustentacaoOral = async (advogado, codigoDaParte) => {
        const descricaoAdv = this.getTextoNomeAdvMaisOab(advogado, true);
        const chaveModal = this.gerarChaveModal(advogado, codigoDaParte);

        try {
            runInAction(() => {
                this.processandoExclusao.set(chaveModal, true);
            });

            const response = await this.advogadoSustentacaoOralService.excluirSustentacaoOral(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                this.getNumeroSiglaOAB(advogado),
                codigoDaParte
            );

            if (response === true) {
                await this.salaSessaoStore.recarregarProcesso(this.registro, false, true);
                this.salaSessaoStore.ordenarProcessos();
                await this.advogadoSustentacaoOralService.notificarAlteracaoAdvogado(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    this.sessaoStore.clienteEnvelopeId
                );

                this.mensagemStore.abrirMensagemSucesso(`Inscrição excluída com sucesso [Adv. ${descricaoAdv}]`);
            } else {
                this.mensagemStore.abrirMensagemErro(response);
            }
        } finally {
            runInAction(() => {
                this.processandoExclusao.set(chaveModal, false);
            });
            this.fecharModalConfirmacaoExclusao(chaveModal);
        }
    };

    getNumeroSiglaOAB(adv) {
        if (adv.regOAB?.numero && adv.regOAB.siglaUf) {
            if (adv.regOAB.letra) {
                return `${adv.regOAB.numero}-${adv.regOAB.siglaUf}-${adv.regOAB.letra}`;
            } else {
                return `${adv.regOAB.numero}-${adv.regOAB.siglaUf}`;
            }
        }

        return '';
    }

    getParteAtual(pedido) {
        // Primeiro tenta busca por código (mais confiável)
        if (pedido.codigoDaParte) {
            const partePorCodigo = this.listaPartes.find(
                (parte) => parte.codigo === pedido.codigoDaParte
            );
            if (partePorCodigo) {
                return partePorCodigo;
            }
        }
        // Fallback: busca por nome, ignorando sufixo de desambiguação ex: "(PF)", "(PJ: 123...)"
        const removerSufixo = (nome) => nome?.toString().toLowerCase().trim().replace(/\s*\(p[fj][^)]*\)\s*$/i, '');
        return this.listaPartes.find(
            (parte) =>
                parte.nome &&
                pedido.nomeDaParte &&
                removerSufixo(parte.nome) === removerSufixo(pedido.nomeDaParte)
        );
    }

    /**
     * Executa uma alteração otimista por inscrição: aplica o valor pretendido na hora, persiste e, em caso de
     * falha, faz rollback. A mensagem de erro do backend é exibida pelo interceptor global de resposta.
     *
     * @param {string} chaveModal Chave de controle de processamento da inscrição.
     * @param {() => void} aplicarOtimista Mutação otimista no modelo.
     * @param {() => void} reverter Desfaz a mutação otimista no erro.
     * @param {() => Promise<boolean|string>} persistir Chamada ao backend (true em sucesso).
     */
    async executarAlteracaoOtimista(chaveModal, aplicarOtimista, reverter, persistir) {
        runInAction(() => {
            aplicarOtimista();
            this.processandoPresencaParticipacao.set(chaveModal, true);
        });

        try {
            const resposta = await persistir();

            if (resposta !== true) {
                throw new Error(typeof resposta === 'string' ? resposta : 'Falha ao alterar a inscrição.');
            }

            await this.advogadoSustentacaoOralService.notificarAlteracaoAdvogado(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                this.sessaoStore.clienteEnvelopeId
            );
        } catch (error) {
            console.error(error);
            runInAction(reverter);
        } finally {
            runInAction(() => {
                this.processandoPresencaParticipacao.set(chaveModal, false);
            });
        }
    }

    handleChangePresencaAdvogado = async (event, pedido, advogado, inscricao) => {
        const chaveModal = this.gerarChaveModal(advogado, pedido.codigoDaParte);
        const novoValor = event.target.value;
        const presencaAnterior = advogado.presente;

        await this.executarAlteracaoOtimista(
            chaveModal,
            () => {
                advogado.presente = novoValor;
            },
            () => {
                advogado.presente = presencaAnterior;
            },
            () => {
                if (!inscricao?.id) {
                    throw new Error('inscricao.id não pode ser nulo');
                }

                return this.advogadoSustentacaoOralService.alterarPresencaInscricao(inscricao.id, novoValor);
            }
        );
    };

    handleChangeParticipacaoAdvogado = async (event, pedido, advogado, inscricao) => {
        const chaveModal = this.gerarChaveModal(advogado, pedido.codigoDaParte);
        const novoValor = event.target.value;
        const estadoAnterior = {
            modoParticipacao: advogado.modoParticipacao,
            presente: advogado.presente,
            preferencia: advogado.preferencia,
            sustentacaoOral: advogado.sustentacaoOral
        };

        await this.executarAlteracaoOtimista(
            chaveModal,
            () => {
                advogado.modoParticipacao = novoValor;

                if (novoValor === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
                    advogado.presente = SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo;

                    if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
                        advogado.preferencia = false;
                        advogado.sustentacaoOral = false;
                    }
                }
            },
            () => {
                advogado.modoParticipacao = estadoAnterior.modoParticipacao;
                advogado.presente = estadoAnterior.presente;
                advogado.preferencia = estadoAnterior.preferencia;
                advogado.sustentacaoOral = estadoAnterior.sustentacaoOral;
            },
            () => {
                if (!inscricao?.id) {
                    throw new Error('inscricao.id não pode ser nulo');
                }

                return this.advogadoSustentacaoOralService.alterarModoParticipacaoInscricao(inscricao.id, novoValor);
            }
        );
    };

    handleChangeEstadoSustentacaoOral = async (event, pedido, advogado, inscricao) => {
        const chaveModal = this.gerarChaveModal(advogado, pedido.codigoDaParte);
        const codEstado = Number.parseInt(event.target.value, 10);
        const estadoAnteriorInscricao = inscricao.estadoSustentacaoOral;
        const estadoAnteriorAdvogado = advogado.estadoSustentacaoOral;
        const novoEstado = {
            id: codEstado,
            descricao: EstadoSustentacaoOral.getDescricaoByCodigo(codEstado)
        };

        await this.executarAlteracaoOtimista(
            chaveModal,
            () => {
                inscricao.estadoSustentacaoOral = novoEstado;
                advogado.estadoSustentacaoOral = novoEstado;
            },
            () => {
                inscricao.estadoSustentacaoOral = estadoAnteriorInscricao;
                advogado.estadoSustentacaoOral = estadoAnteriorAdvogado;
            },
            () => this.advogadoSustentacaoOralService.alterarEstadoInscricao(inscricao.id, codEstado)
        );
    };

    gravarInformacoesParticipacaoAdvogado = async () => {
        await this.processoService.registrarPresencaAdvogadoProcesso(
            this.registro.sessaoId,
            this.registro.processo.numeroCompleto,
            this.inscricaoAdvogado
        );
    };

    handleClickIconePresencaAdvogado = (idIconeAdvogado) => {
        this.abrirPopoverPresencaAdvogado = { [idIconeAdvogado]: true };
    };

    handleClosePresencaAdvogado = () => {
        this.abrirPopoverPresencaAdvogado = false;
    };

    titleIconeAdvogado(situacaoPresenca, situacaoParticipacao) {
        let title = 'Editar informação de presença (';

        switch (situacaoPresenca) {
            case SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo:
                title += SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.descricaoPresencaCurta;
                break;
            case SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo:
                title += SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.descricaoPresencaCurta;
                break;
            default:
                title += SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.descricaoPresencaCurta;
                break;
        }

        title += ') e modo de participação (';

        switch (situacaoParticipacao) {
            case MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo:
                title += MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.descricao;
                break;
            case MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo:
                title += MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.descricao;
                break;
            case MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo:
                title += MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.descricao;
                break;
            case MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo:
                title += MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.descricao;
                break;
            case MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo:
                title += MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.descricao;
                break;
            default:
                title += MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.descricao;
                break;
        }

        title += ')';

        return title;
    }

    getTextoNomeAdvMaisOab(adv, oabEntreParenteses = false) {
        return `${adv.nome} ${this.getTextoOab(adv, oabEntreParenteses)}`;
    }

    getTextoOab(adv, entreParenteses = false) {
        let texto = '';

        if (adv.regOAB) {
            texto += entreParenteses ? '(' : '- ';
            texto += 'OAB: ';

            if (!adv.regOAB.numero || !adv.regOAB.siglaUf) {
                texto += 'não informada ou com dados incompletos';
            } else if (adv.regOAB.letra) {
                texto += `${adv.regOAB.numero}-${adv.regOAB.letra}/${adv.regOAB.siglaUf}`;
            } else {
                texto += `${adv.regOAB.numero}/${adv.regOAB.siglaUf}`;
            }

            texto += entreParenteses ? ')' : '';
        }

        return texto;
    }

    titleAdvogado(adv) {
        return (
            <Typography
                display="inline"
                fontWeight="bold"
            >
                {this.getTextoNomeAdvMaisOab(adv)}
            </Typography>
        );
    }

    get isJulgamentoPresencial() {
        return this.registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo;
    }

    get isJulgamentoExclusivamenteVirtual() {
        return SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
            this.sessaoStore?.sessaoSelecionada?.tipoJulgamento
        );
    }

    get renderOpcaoParticipacaoVirtual() {
        if (!this.isJulgamentoPresencial) {
            return <>{MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.descricao}</>;
        }

        return (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.descricao}
                <Tooltip
                    title={
                        <Typography>
                            Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                        </Typography>
                    }
                >
                    <Warning
                        style={{
                            marginLeft: '4px',
                            color: 'darkorange',
                            width: '20px',
                            height: '20px'
                        }}
                    />
                </Tooltip>
            </Stack>
        );
    }

    renderOpcaoComAlertaSessaoExclusivamenteVirtual(descricao) {
        return (
            <Stack direction="row">
                {descricao}
                {this.isJulgamentoExclusivamenteVirtual && (
                    <Tooltip title={<Typography>Opção incompatível com a modalidade da sessão.</Typography>}>
                        <Warning
                            style={{
                                marginLeft: '4px',
                                color: 'darkorange',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </Tooltip>
                )}
            </Stack>
        );
    }

    renderOpcaoJulgamentoSessaoAoVivo(modoParticipacao) {
        if (this.isJulgamentoExclusivamenteVirtual) {
            return this.renderOpcaoComAlertaSessaoExclusivamenteVirtual(modoParticipacao.descricao);
        }

        return <>{modoParticipacao.descricao}</>;
    }

    get renderOpcaoSustentacaoOralEletronica() {
        return (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.descricao}
                {SituacaoJulgamentoProcessoBusiness.isProcessoRemetido(
                    this.registro?.tipoJulgamento,
                    this.registro?.remessaJulgamento
                ) && (
                    <Tooltip
                        title={
                            <Typography>
                                ATENÇÃO: Avalie a necessidade de realizar a inscrição de sustentação oral eletrônica,
                                pois o processo já foi remetido.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {this.registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo && (
                    <Tooltip
                        title={
                            <Typography>
                                Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {!this.registro.processo.permiteSustentacao && (
                    <Tooltip title={<Typography>A classe processual não permite sustentação.</Typography>}>
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
            </Stack>
        );
    }

    get isProcessoEmJulgamentoVirtual() {
        if (!this.registro?.tipoJulgamento) {
            return false;
        }

        return SituacaoJulgamentoProcessoBusiness.isProcessoEmJulgamentoVirtual(
            this.registro.tipoJulgamento,
            this.registro.remessaJulgamento
        );
    }

    get renderOpcaoPedidoDestaque() {
        return (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.descricao}
                {!this.isJulgamentoExclusivamenteVirtual && (
                    <Tooltip title={<Typography>Opção incompatível com a modalidade da sessão.</Typography>}>
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {!this.registro.processo.permiteSustentacao && (
                    <Tooltip title={<Typography>A classe processual não permite sustentação.</Typography>}>
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
            </Stack>
        );
    }

    renderIconePresencaAdvogado = (pedido, adv) => {
        // Sequencial no id necessário caso o mesmo processo seja aberto no painel de detalhes e na modal.
        const oab = this.getNumeroSiglaOAB(adv);
        const idIconeAdvogado = `iconeAdvogado-${oab}-${pedido.codigoDaParte}`;
        const corIconeAdvogado = SituacaoInscricaoAdvogado.getCorByCodigo(adv.presente);
        const tamanhoIconeAdvogado = '21px';
        const titleIconeAdvogado = this.titleIconeAdvogado(adv.presente, adv.modoParticipacao);
        const inscricao = this.observableProps.registro?.detalhes?.inscricoes?.find(
            (inscricao) =>
                inscricao.codigoDaParte === pedido.codigoDaParte && inscricao.advogado.regOAB.id === adv.regOAB.id
        );
        return (
            <>
                <div
                    style={{
                        width: '36px',
                        minWidth: '36px',
                        maxWidth: '36px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <IconeAdvogadoModoParticipacao
                        modoParticipacao={adv.modoParticipacao}
                        deferimento={adv.deferimento}
                        inscricao={inscricao}
                        style={{
                            verticalAlign: 'middle'
                        }}
                    />
                </div>
                <IconButton
                    style={{ padding: '4px' }}
                    onClick={() => this.handleClickIconePresencaAdvogado(idIconeAdvogado)}
                    disabled={
                        this.isInscricaoTransportada(adv) ||
                        !!this.processandoPresencaParticipacao.get(this.gerarChaveModal(adv, pedido.codigoDaParte))
                    }
                >
                    <IconeAdvogado
                        placement="top"
                        title={<Typography className="tooltipBotao">{titleIconeAdvogado}</Typography>}
                        removerEstiloPadrao
                        id={idIconeAdvogado}
                        style={{
                            cursor: 'pointer',
                            color: corIconeAdvogado,
                            fill: corIconeAdvogado,
                            fillOpacity: 1,
                            width: tamanhoIconeAdvogado,
                            height: tamanhoIconeAdvogado
                        }}
                    />
                </IconButton>
                <PopoverSecretaria
                    open={this.abrirPopoverPresencaAdvogado[idIconeAdvogado] || false}
                    onClose={this.handleClosePresencaAdvogado}
                    anchorEl={() => document.getElementById(idIconeAdvogado)}
                    padding="20px"
                >
                    <Card sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                        <CardHeader
                            title={this.titleAdvogado(adv)}
                            slotProps={{
                                title: { variant: 'h5' }
                            }}
                        />
                        <CardContent>
                            <FormControl>
                                <FormLabel id="advogado-participacao-presenca">Presença</FormLabel>
                                <RadioGroup
                                    aria-labelledby="advogado-participacao-presenca"
                                    name="presenca"
                                    value={adv.presente}
                                    onChange={(event) =>
                                        this.handleChangePresencaAdvogado(event, pedido, adv, inscricao)
                                    }
                                >
                                    <FormControlLabel
                                        disabled={this.isPresencaDesabilitada(adv)}
                                        label={SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.descricaoPresencaCurta}
                                        value={SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo}
                                        control={<Radio />}
                                    />
                                    <FormControlLabel
                                        disabled={this.isPresencaDesabilitada(adv)}
                                        label={SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.descricaoPresencaCurta}
                                        value={SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo}
                                        control={<Radio />}
                                    />
                                    <FormControlLabel
                                        disabled={this.isPresencaDesabilitada(adv)}
                                        label={SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.descricaoPresencaCurta}
                                        value={SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo}
                                        control={<Radio />}
                                    />
                                </RadioGroup>
                            </FormControl>
                            <FormControl>
                                <FormLabel id="advogado-participacao-modo">Modo de participação</FormLabel>
                                <RadioGroup
                                    aria-labelledby="advogado-participacao-modo"
                                    name="modoParticipacao"
                                    value={adv.modoParticipacao}
                                    onChange={(event) =>
                                        this.handleChangeParticipacaoAdvogado(event, pedido, adv, inscricao)
                                    }
                                >
                                    <FormControlLabel
                                        label={MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.descricao}
                                        value={MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo}
                                        control={<Radio />}
                                        disabled={true}
                                    />
                                    <FormControlLabel
                                        disabled={this.isJulgamentoPresencial}
                                        label={this.renderOpcaoParticipacaoVirtual}
                                        value={MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo}
                                        control={<Radio />}
                                    />
                                    <FormControlLabel
                                        disabled={this.isJulgamentoExclusivamenteVirtual}
                                        label={this.renderOpcaoJulgamentoSessaoAoVivo(
                                            MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL
                                        )}
                                        value={MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo}
                                        control={<Radio />}
                                    />
                                    <FormControlLabel
                                        disabled={this.isJulgamentoExclusivamenteVirtual}
                                        label={this.renderOpcaoJulgamentoSessaoAoVivo(
                                            MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL
                                        )}
                                        value={MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo}
                                        control={<Radio />}
                                    />
                                    <FormControlLabel
                                        label={this.renderOpcaoSustentacaoOralEletronica}
                                        value={MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo}
                                        control={<Radio />}
                                        disabled={
                                            !this.registro.processo.permiteSustentacao ||
                                            this.registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo
                                        }
                                    />
                                    <FormControlLabel
                                        label={this.renderOpcaoPedidoDestaque}
                                        value={MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo}
                                        control={<Radio />}
                                        disabled={!this.isJulgamentoExclusivamenteVirtual}
                                    />
                                </RadioGroup>
                            </FormControl>
                            {this.isComponenteHabilitado('AlterarEstadoSustentacaoOral') && (
                                <FormControl>
                                    <FormLabel id="advogado-estado-sustentacao">Estado</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="advogado-estado-sustentacao"
                                        name="estadoSustentacaoOral"
                                        value={adv?.estadoSustentacaoOral?.id?.toString() || ''}
                                        onChange={(event) =>
                                            this.handleChangeEstadoSustentacaoOral(event, pedido, adv, inscricao)
                                        }
                                    >
                                        <FormControlLabel
                                            label={ESTADO_SUSTENTACAO_ORAL.SUSTENTOU.descricao}
                                            value={ESTADO_SUSTENTACAO_ORAL.SUSTENTOU.codigo.toString()}
                                            control={<Radio />}
                                        />
                                        <FormControlLabel
                                            label={ESTADO_SUSTENTACAO_ORAL.NAO_SUSTENTOU.descricao}
                                            value={ESTADO_SUSTENTACAO_ORAL.NAO_SUSTENTOU.codigo.toString()}
                                            control={<Radio />}
                                        />
                                        <FormControlLabel
                                            label={ESTADO_SUSTENTACAO_ORAL.TEVE_ASSEGURADA.descricao}
                                            value={ESTADO_SUSTENTACAO_ORAL.TEVE_ASSEGURADA.codigo.toString()}
                                            control={<Radio />}
                                        />
                                        <FormControlLabel
                                            label={ESTADO_SUSTENTACAO_ORAL.NAO_TEVE_ASSEGURADA.descricao}
                                            value={ESTADO_SUSTENTACAO_ORAL.NAO_TEVE_ASSEGURADA.codigo.toString()}
                                            control={<Radio />}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            )}
                        </CardContent>
                    </Card>
                </PopoverSecretaria>
            </>
        );
    };

    render() {
        if (
            !this.registro?.pedidoSustentacaoOral?.pedidosDetalhados ||
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.length === 0
        ) {
            return null;
        }

        return (
            <>
                {this.observableProps.semDivisor ? null : (
                    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.3)', marginBottom: '5px', marginTop: '5px' }} />
                )}
                <div style={{ marginBottom: '4px', color: '#01579B' }}>
                    <Typography fontWeight={'bold'}>Inscrições (Preferências / Sustentações orais):</Typography>
                </div>
                <div style={{ display: 'flex', flexGrow: 1, overflowY: 'auto' }}>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: '8px',
                            width: '100%',
                            minHeight: '55px',
                            maxHeight: this.observableProps.visualizacaoVertical ? 'auto' : '40px'
                        }}
                    >
                        <ul
                            style={{
                                paddingInlineStart: '0px',
                                width: '100%',
                                listStyleType: 'none',
                                margin: '0px'
                            }}
                        >
                            {this.registro.pedidoSustentacaoOral?.pedidosDetalhados.map((pedido) => {
                                return (
                                    <li
                                        key={`${pedido.codigoDaParte}-${pedido.nomeDaParte}`}
                                        style={{ marginLeft: '20px' }}
                                    >
                                        <span className="lista">
                                            <span className="titulo">
                                                {pedido.denominacaoDaParte
                                                    ? pedido.denominacaoDaParte + ': '
                                                    : '(Denominação não informada) '}{' '}
                                                <ExibirOcultarNome
                                                    abreviarNome={this.observableProps.registro.segredoJustica}
                                                    nome={pedido.nomeDaParte}
                                                    estiloTexto={{ fontWeight: 'bold' }}
                                                />
                                                <SustentacaoOralAnterior
                                                    registro={this.registro}
                                                    pedido={pedido}
                                                />
                                            </span>
                                            <span className="lista-align-left">
                                                {pedido.advogados.map((adv) => {
                                                    const chaveModal = this.gerarChaveModal(adv, pedido.codigoDaParte);

                                                    const exclusaoEmAndamento =
                                                        this.processandoExclusao.get(chaveModal);

                                                    if (exclusaoEmAndamento) {
                                                        return null;
                                                    }

                                                    const inscricao =
                                                        this.observableProps.registro?.detalhes?.inscricoes?.find(
                                                            (inscricao) =>
                                                                inscricao.codigoDaParte === pedido.codigoDaParte &&
                                                                inscricao.advogado.regOAB.id === adv.regOAB.id
                                                        );

                                                    return (
                                                        <div
                                                            key={chaveModal}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            {this.renderIconePresencaAdvogado(pedido, adv)}
                                                            {this.isInscricaoTransportada(adv) && (
                                                                <Tooltip
                                                                    placement="top"
                                                                    title={
                                                                        <Typography className="tooltipBotao">
                                                                            Sustentação oral eletrônica proveniente da
                                                                            sessão de {adv.dataSessaoOrigem || 'sessão anterior'}
                                                                            {' '}(art. 134-A, § 6º-A, RITST)
                                                                        </Typography>
                                                                    }
                                                                >
                                                                    <History
                                                                        sx={{
                                                                            fontSize: '18px',
                                                                            color: 'darkorange',
                                                                            marginRight: '4px'
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                            <ModalEdicaoAdvogadoProcesso
                                                                advogado={adv}
                                                                parteAtual={this.getParteAtual(pedido)}
                                                                registro={this.registro}
                                                            />
                                                            {!this.isInscricaoTransportada(adv) && (
                                                            <Tooltip
                                                                placement="top"
                                                                title={
                                                                    <Typography className="tooltipBotao">
                                                                        Remover inscrição de advogado
                                                                    </Typography>
                                                                }
                                                            >
                                                                <span>
                                                                    <IconButton
                                                                        disabled={
                                                                            !!this.processandoExclusao.get(chaveModal)
                                                                        }
                                                                        style={{ padding: '4px' }}
                                                                        onClick={() =>
                                                                            this.handleClickExclusaoAdv(
                                                                                adv,
                                                                                pedido.codigoDaParte
                                                                            )
                                                                        }
                                                                        size="large"
                                                                    >
                                                                        <Delete className="fillBlack" />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            )}
                                                            <ModalConfirmacao
                                                                open={!!this.modaisConfirmacaoExclusao.get(chaveModal)}
                                                                tipoConfirmacao={TIPO_CONFIRMACAO.EXCLUSAO}
                                                                titulo={'Remoção de inscrição de advogado'}
                                                                callbackCancelar={() =>
                                                                    this.handleClickCancelarExclusaoAdv(
                                                                        adv,
                                                                        pedido.codigoDaParte
                                                                    )
                                                                }
                                                                callbackConfirmar={() =>
                                                                    this.excluirSustentacaoOral(
                                                                        adv,
                                                                        pedido.codigoDaParte
                                                                    )
                                                                }
                                                            >
                                                                <Typography display={'inline'}>
                                                                    Deseja realmente excluir a inscrição d
                                                                    {adv?.genero?.startsWith('F') ? 'a' : 'o'} advogad
                                                                    {adv?.genero?.startsWith('F') ? 'a' : 'o'}{' '}
                                                                </Typography>
                                                                <Typography
                                                                    display={'inline'}
                                                                    fontWeight={'bold'}
                                                                >
                                                                    {this.getTextoNomeAdvMaisOab(adv, true)}
                                                                </Typography>
                                                                <Typography display={'inline'}>?</Typography>
                                                            </ModalConfirmacao>
                                                            <TableAdvogado
                                                                advogado={adv}
                                                                inscricao={inscricao}
                                                                key={`${chaveModal}-table`}
                                                                className="lista-align"
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </span>
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export default inject('stores')(observer(PedidosSustentacaoOral));
